import { useQuery } from 'react-query';
import axios from 'axios';
import { MonitorQueueAPI } from '../../constants/API';
import { getMonitorToken, queueScreenHeaders } from '../../constants/HeadersAPI';
import { parseMonitorResponse } from '../../utils/QueuePage/parseMonitorResponse';

export type QueueTickersRespType = {
  tickers: TickerType[];
};

type TickerType = {
  id: number;
  text: string;
};

export const useGetQueueTickers = () => {
  const {
    data: queueTickersResp,
    isFetching: isLoadingQueueTickers,
    isSuccess: isQueueTickersRecieved
  } = useQuery(
    ['QueueTickers', getMonitorToken()],
    async () => {
      const { data } = await axios.get(
        MonitorQueueAPI.getQueueTickers,
        queueScreenHeaders()
      );
      return parseMonitorResponse<QueueTickersRespType>(data);
    },
    {
      isDataEqual: (prev, next) =>
        JSON.stringify(prev?.tickers) === JSON.stringify(next?.tickers),
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      staleTime: 15000,
      refetchOnWindowFocus: false
    }
  );

  return { queueTickersResp, isLoadingQueueTickers, isQueueTickersRecieved };
};
